import React, { useEffect, useState } from 'react';
import { Accordion, Alert, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import Titulo from '../elements/Titulo';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { useAuth } from '../context/AuthContext';
import { Helmet } from 'react-helmet';

const CategoriesForm = () => {

    const [categoryTypeInput, setCategoryTypeInput] = useState('');
    const [categoryInput, setCategoryInput] = useState('');
    const [categoryTypes, setCategoryTypes] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryType, setSelectedCategoryType] = useState('');
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const { user } = useAuth();
    const [dataResponse, setDataResponse] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingCategories, setLoadingCategories] = useState(false);
    const [error, setError] = useState(false);


    // Función para hacer la llamada al API
    const saveCategoryTypeToApi = async (categoryType) => {
        try {
            const { data } = await dotoniwoofApi.post("/categoryType.php",
                JSON.stringify({
                    firebase_UID: user.uid,
                    categoryTypeName: categoryType
                }));
            setDataResponse(data);
            if (data.code === 201) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
                getCategoryType();
            } else {
                throw new Error('Failed to save category type');
            }
        } catch (error) {
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
        }
    };

    const saveCategoryToApi = async (category) => {
        try {
            const { data } = await dotoniwoofApi.post("/category.php",
                JSON.stringify({
                    firebase_UID: user.uid,
                    categoryName: category,
                    id_category_type: selectedCategoryType
                }));
            setDataResponse(data);
            if (data.code === 201) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
                getCategoryByType(selectedCategoryType);
            } else {
                throw new Error('Failed to save category type');
            }
        } catch (error) {
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
        }
    };

    const getCategoryType = async () => {
        await dotoniwoofApi.get(`/categoryType.php`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setCategoryTypes(responseApi.message);
                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                    setLoading(false);
                }
            )
    }

    const getCategoryByType = async (categoryType) => {
        await dotoniwoofApi.get(`/category.php/${categoryType}`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setCategories(responseApi.message);
                } else {
                    setCategories([]);
                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                    setLoadingCategories(false);
                }
            )
    }

    const handleCategoryTypeChange = (e) => {
        const categoryTypeId = e.target.value;
        setSelectedCategoryType(categoryTypeId);
        if (categoryTypeId) {
            getCategoryByType(categoryTypeId); // Obtener categorías basadas en el tipo seleccionado
        } else {
            setCategories([]); // Vaciar categorías si no se selecciona ningún tipo
        }
    };


    useEffect(() => {
        getCategoryType();
    }, [])

    // Agregar Tipo de Categoría
    const addCategoryType = (e) => {
        e.preventDefault();
        if (categoryTypeInput.trim()) {
            saveCategoryTypeToApi(categoryTypeInput); // Llamada al API para persistir el dato
            setCategoryTypeInput(''); // Limpiar el campo de texto
        }
    };

    // Agregar Tipo de Categoría
    const addCategory = (e) => {
        e.preventDefault();
        if (categoryInput.trim()) {
            saveCategoryToApi(categoryInput); // Llamada al API para persistir el dato
            setCategoryInput(''); // Limpiar el campo de texto
        }
    };


    return (
        <>

            <Helmet>
                <title>Categorías</title>
            </Helmet>
            <NavContainer></NavContainer>
            <OffCanvasNav></OffCanvasNav>

            <Container >
                <Titulo>Configuracion de categorías</Titulo>
                <hr></hr>
                <Row>
                    <Col>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Tipo de Categorías</Accordion.Header>
                                <Accordion.Body>
                                    <Container>
                                        {/* Alerta de confirmación de éxito */}
                                        {showSuccessAlert && (
                                            <Alert variant="success">
                                                {dataResponse.message}
                                            </Alert>
                                        )}

                                        {/* Alerta de error */}
                                        {showErrorAlert && (
                                            <Alert variant="danger">
                                                ERROR AL CREAR LA CATEGORIA
                                            </Alert>
                                        )}

                                        {/* Formulario para ingresar el nombre del tipo de categoría */}
                                        <Form onSubmit={addCategoryType}>
                                            <Form.Group controlId="formCategoryType">
                                                <Form.Label>Nombre del tipo de categoría</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={categoryTypeInput}
                                                    onChange={(e) => setCategoryTypeInput(e.target.value)}
                                                    placeholder="Escriba el tipo de categoría a crear"
                                                    required
                                                />
                                            </Form.Group>
                                            <br></br>
                                            <Button variant="primary" type="submit">Crear tipo de Categoría</Button>
                                        </Form>
                                        <br></br>
                                        {!loading && !error && (
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>Tipo de categoría</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {categoryTypes.length > 0 ? (
                                                        categoryTypes.map((categoryType) => (
                                                            <tr key={categoryType.id_category_type}>
                                                                <td>{categoryType.categoryTypeName}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="1" className="text-center">No hay tipo de categorias creadas</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        )}
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>
                            {categoryTypes.length > 0 &&
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Categorías</Accordion.Header>
                                    <Accordion.Body>
                                        {!loading && (
                                            <Form.Group controlId="categoryTypeSelect">
                                                <Form.Label>Tipo de categoria</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    value={selectedCategoryType}
                                                    onChange={handleCategoryTypeChange}
                                                >
                                                    <option value="">-- Selecciones el tipo de categoría --</option>
                                                    {categoryTypes.map((type) => (
                                                        <option key={type.id_category_type} value={type.id_category_type}>
                                                            {type.categoryTypeName}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>


                                        )}
                                        {showSuccessAlert && (
                                            <Alert variant="success">
                                                {dataResponse.message}
                                            </Alert>
                                        )}

                                        {/* Alerta de error */}
                                        {showErrorAlert && (
                                            <Alert variant="danger">
                                                ERROR AL CREAR LA CATEGORIA
                                            </Alert>
                                        )}


                                        {/* Formulario para ingresar el nombre del tipo de categoría */}
                                        <br></br>
                                        <Form onSubmit={addCategory}>
                                            <Form.Group controlId="formCategory">
                                                <Form.Label>Nombre de la categoría</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={categoryInput}
                                                    onChange={(e) => setCategoryInput(e.target.value)}
                                                    placeholder="Escriba la categoría a crear"
                                                    required
                                                />
                                            </Form.Group>
                                            <br></br>
                                            <Button variant="primary" type="submit">Crear Categoría</Button>
                                        </Form>

                                        {!loadingCategories && categories.length > 0 && (
                                            <Table striped bordered hover className="mt-4">
                                                <thead>
                                                    <tr>
                                                        <th>Categorías</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {categories.map((category) => (
                                                        <tr key={category.id_category}>

                                                            <td>{category.category_name}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        )}

                                        {/* Mensaje cuando no hay categorías para mostrar */}
                                        {!loadingCategories && categories.length === 0 && selectedCategoryType && (
                                            <Alert variant="info" className="mt-4">
                                                No hay categorias para el tipo de categoria seleccionado
                                            </Alert>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            }

                        </Accordion>
                    </Col>
                </Row >
            </Container>
        </>

    );
}

export default CategoriesForm;